export default  {
    inserted(el,binding){
        const context = el.__context={
            bindingValue:binding.value,
            keydown(event){
                const value=context.bindingValue;
                switch (event.keyCode){
                    case 37:
                        value.left--;
                        break;
                    case 38:
                        value.top--;
                        break;
                    case 39:
                        value.left++;
                        break;
                    case 40:
                        value.top++;
                        break;
                    case 107:
                        value.width++;
                        break;
                    case 109:
                        value.width>0&&value.width--;
                        break;
                    default:
                        break;
                }
                event.preventDefault();
                event.stopPropagation();
                return false
            }
        };
        el.addEventListener("keydown",context.keydown)
    },
    unbind(el){
        el.removeEventListener("keydown",el.__context.keydown);
        el.__context=null;
    },
    update(el,binding){
        if(binding.oldValue!==binding.value){
            el.__context.bindingValue=binding.value
        }
    },
}

